import { DAYS } from 'src/common/constants'

/**
 * Build the date parts a card displays.
 *
 * Event cards carry `event_start_date`, which WordPress sends as midnight UTC of the
 * event's calendar day. Every other card type carries only `post_date` — the moment the
 * post was created, which is not an event date and must not stand in for one.
 *
 * The timestamp is deliberately read with UTC getters: these values encode a calendar
 * day, so local-time getters shift them to the previous day anywhere behind UTC.
 *
 * @param {object} cardData Card payload from the WordPress REST response.
 * @returns {{year: string, day: string, month: string, weekDay: string}}
 */
export function getCardDate(cardData) {
  const timestamp = cardData?.event_start_date ?? cardData?.post_date

  if (!timestamp) {
    return { year: '', day: '', month: '', weekDay: '' }
  }

  const date = new Date(timestamp * 1000)

  return {
    year: date.getUTCFullYear().toString(),
    day: date.getUTCDate().toString(),
    month: date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' }),
    weekDay: DAYS[date.getUTCDay()],
  }
}
